export const LIST_INDUSTRI_REQUEST = 'LIST_INDUSTRI_REQUEST'
export const LIST_INDUSTRI_SUCCESS = 'LIST_INDUSTRI_SUCCESS'
export const LIST_INDUSTRI_FAIL = 'LIST_INDUSTRI_FAIL'

export const LIST_INDUSTRI_SUMMARY_REQUEST = 'LIST_INDUSTRI_SUMMARY_REQUEST'
export const LIST_INDUSTRI_SUMMARY_SUCCESS = 'LIST_INDUSTRI_SUMMARY_SUCCESS'
export const LIST_INDUSTRI_SUMMARY_FAIL = 'LIST_INDUSTRI_SUMMARY_FAIL'

export const CREATE_INDUSTRI_REQUEST = 'CREATE_INDUSTRI_REQUEST'
export const CREATE_INDUSTRI_SUCCESS = 'CREATE_INDUSTRI_SUCCESS'
export const CREATE_INDUSTRI_FAIL = 'CREATE_INDUSTRI_FAIL'

export const DETAIL_INDUSTRI_REQUEST = 'DETAIL_INDUSTRI_REQUEST'
export const DETAIL_INDUSTRI_SUCCESS = 'DETAIL_INDUSTRI_SUCCESS'
export const DETAIL_INDUSTRI_FAIL = 'DETAIL_INDUSTRI_FAIL'

export const UPDATE_INDUSTRI_REQUEST = 'UPDATE_INDUSTRI_REQUEST'
export const UPDATE_INDUSTRI_SUCCESS = 'UPDATE_INDUSTRI_SUCCESS'
export const UPDATE_INDUSTRI_FAIL = 'UPDATE_INDUSTRI_FAIL'

export const DELETE_INDUSTRI_REQUEST = 'DELETE_INDUSTRI_REQUEST'
export const DELETE_INDUSTRI_SUCCESS = 'DELETE_INDUSTRI_SUCCESS'
export const DELETE_INDUSTRI_FAIL = 'DELETE_INDUSTRI_FAIL'

export const RESET_INDUSTRI = 'RESET_INDUSTRI'